import { Band, Eyebrow, BandCta, displayFont } from "./band-helpers";

export function KitchenStoryBand() {
  return (
    <Band
      className="bg-[#f1f7ee] py-0"
    >
      <div className="grid min-h-[28rem] gap-0 lg:grid-cols-[0.98fr_1.02fr]">
        <div className="relative aspect-video overflow-hidden lg:aspect-auto lg:min-h-0">
          <iframe
            src="https://www.youtube.com/embed/ysz5S6PUM-U?rel=0"
            title="Aso Rock kitchen story demo video"
            className="h-full w-full"
            loading="lazy"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>

        <div className="flex flex-col justify-center px-5 py-10 lg:px-8 lg:py-16">
          <Eyebrow>Kitchen story / chef note</Eyebrow>
          <h2
            className={`${displayFont.className} mt-4 max-w-xl text-[clamp(1.7rem,3.2vw,2.7rem)] font-bold leading-[1.1] tracking-tight storefront-text-heading`}
          >
            A cinematic story band that still feels commercial.
          </h2>
          <p className="mt-5 max-w-xl text-base leading-7 storefront-text-body sm:text-lg">
            This is the place for prep footage, chef messaging, or a deeper
            note about how the kitchen works. It gives the page atmosphere
            without losing the selling intent.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <BandCta href="/menu" label="Use this story pattern" />
            <BandCta href="/menu" label="Open the menu" tone="secondary" />
          </div>
        </div>
      </div>
    </Band>
  );
}
